import Image from 'components/Image';
import styles from './styles/PoweredBy.module.scss';

export default function PoweredBy({ image }: { image: string }) {
  return (
    <div className={styles.PoweredByBlock}>
      Powered By
      <Image src={image} />
    </div>
  );
}
